import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cartActions } from "../../store/cart-slice";
import baseUrl from "../../url/baseUrl";
import CartRow from "./CartRow";

const CartTable = (props) => {
  const isLogin = useSelector((state) => state.loginUser.isLogin);
  const dispatch = useDispatch();
  const items = props.items;
  let content = <p>No items.</p>;

  // thiết lập tik lên checkbox
  const [selectedItems, setSelectedItems] = useState([]);

  // handle method khi chọn tất cả checkbox
  const handleSelectAll = (e) => {
    // nếu checkbox được check
    if (e.target.checked) {
      // set selectedItems thành array chứa các id của các sp
      setSelectedItems(items.map((item) => item._id));
      // nếu bỏ check
    } else {
      // set selectedItems thành []
      setSelectedItems([]);
    }
  };

  // Method xử lý chọn các checbox
  // 1.Nếu vốn được chọn sẵn => id đang có trong selectedItems array => loại ra khỏi array
  // 2. Nếu chưa chọn => id chưa có trong array selectedItems => thêm id vào
  const handleSelect = (id) => {
    setSelectedItems((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((itemId) => itemId !== id)
        : [...prevSelected, id]
    );
  };

  // xóa các item được tik
  const handleDelete = async () => {
    if (isLogin) {
      try {
        const response = await fetch(baseUrl + "/remove-item-selected", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          credentials: "same-origin",
          mode: "cors",

          body: JSON.stringify({
            select: selectedItems,
          }),
        });

        if (response.status === 404) {
          throw new Error("Cannot Delete product!");
        }

        if (response.status !== 200) {
          throw new Error("Something went wrong with server.");
        }

        const data = await response.json();
        //update for items
        dispatch(cartActions.updateCartItems(data));
        // update for totalPrice
        const priceArr = data.map((prod) => +prod.totalPriceOfProduct);
        dispatch(
          cartActions.updatedCartPrice(priceArr.reduce((a, b) => a + b, 0))
        );
      } catch (err) {
        console.log(err);
      }
    } else {
      const unLogCart = JSON.parse(localStorage.getItem("unLogCart")) || [];
      const newCart = unLogCart.filter(
        (item) => !selectedItems.includes(item._id)
      );
      localStorage.setItem("unLogCart", JSON.stringify(newCart));
      dispatch(cartActions.updateCartItems(newCart));
      const priceArr = newCart.map((prod) => +prod.totalPriceOfProduct);
      dispatch(
        cartActions.updatedCartPrice(priceArr.reduce((a, b) => a + b, 0))
      );
    }
    // thiết lập này để bỏ tích lên checkbox tổng sau khi xóa
    setSelectedItems([]);
  };

  if (items.length > 0) {
    content = (
      <div className="table-responsive">
        {selectedItems.length > 0 && (
          <button onClick={handleDelete} className="btn btn-outline-danger">
            Delete Selected
          </button>
        )}
        <table className=" table table-bordered table-hover cart_table">
          <thead className="table-light cart_table_head">
            <tr>
              <th>
                <input
                  type="checkbox"
                  // checkbox này chỉ đc checked khi tất cả checkbox con được checked
                  checked={
                    selectedItems.length === items.length && items.length > 0
                  }
                  onChange={handleSelectAll}
                />
              </th>
              <th className="cart_th">Ảnh</th>
              <th className="cart_th">SP</th>
              <th className="cart_th">Size</th>
              <th className="cart_th">Đơn giá</th>
              <th className="cart_th">SL</th>
              <th className="cart_th">Tổng</th>
              <th className="cart_th">Xóa</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, i) => (
              <CartRow
                key={i}
                item={item}
                isSelected={selectedItems.includes(item._id)}
                onSelect={handleSelect}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return content;
};

export default CartTable;
